
import { func } from '../../main';
import axios from '../../api'
import router from '../../router';

const state = {
    TaskTypeList: [],
    TaskTypeStepList: [],
    TaskTypeListForEdit: [],
    TaskTypeNo: "",
    TaskTypeNoMoreData: false,
    OrgJobList:[],
    Loading:false,
    TaskTypeAccess:"0"
};


const getters = {
    GetTaskTypeList(state:any) {
        return state.TaskTypeList;
    },
    GetTaskTypeStepList(state:any) {
        return state.TaskTypeStepList;
    },
    GetTaskTypeNoMoreData(state:any) {
        return state.TaskTypeNoMoreData;
    },
    GetTaskTypeListForEdit(state:any) {
        return state.TaskTypeListForEdit;
    },
  
    GetTaskTypeNo(state:any) {
        return state.TaskTypeNo;
    },
    GetTaskTypeAccess(state:any){
        return state.TaskTypeAccess;
    }
};

const mutations = {
    SetTaskTypeNoMoreData(state: any, val: any) {
        state.TaskTypeNoMoreData = val;
    },
    SetTaskTypeList(state:any, list:any) {
        state.TaskTypeList = list;
    },
    SetTaskTypeStepList(state:any, list:any) {
        state.TaskTypeStepList = list;
    },
    SetTaskTypeListForEdit(state:any, list:any) {
        state.TaskTypeListForEdit = list;
    },
  
    SetTaskTypeNo(state:any, no:any) {
        state.TaskTypeNo = no;
    },
    SetTaskTypeAccess(state:any,no:any){
        state.TaskTypeAccess=no;
    },
    AddTaskTypeList(state: any, list: any) {
        state.TaskNoteList = state.TaskNoteList.concat(list);
    },
    AddTaskTypeListForEdit(state: any, list: any) {
        state.TaskTypeListForEdit = state.TaskTypeListForEdit.concat(list);
    },
};

const actions = {
    GetTaskTypeListFromServer(context:any, Filter:any) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("Task/GetTaskTypeList", {
            params: {
                page: Filter.pageId,
                filterId: Filter.filterId,
                searchKey:Filter.searchKey
            }
        })
           .then(data => {
               context.commit("SetLoading", false);
               context.commit("SetTaskTypeList", data.data);
            });
    },
    GetTaskTypeStepListFromServer(context:any, Filter:any) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("Task/GetTaskTypeStepList", {
            params: {
                id: Filter.taskTypeId,
                searchKey: Filter.searchKey
            }
        })
           .then(data => {
                context.commit("SetLoading", false);
                context.commit("SetTaskTypeStepList", data.data);
            });
    },
    GetTaskTypeAccessFromServer(context:any) {
        axios.get("Task/CanViewTaskType")
           .then(data => {
                context.commit("SetTaskTypeAccess", data.data.toString());
            });
    },
    GetTaskTypeListForEditFromServer(context:any, Filter:any) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("Task/GetTaskTypeListForEdit", {
            params: {
                page: Filter.pageId,
                filterId: Filter.filterId,
                searchKey: Filter.searchKey
            }
        })
           .then(data => {
                context.commit("SetLoading", false);
               //context.commit("SetTaskTypeListForEdit", data.data);


               if (data.data.length < 1) {
                   context.commit("SetTaskTypeNoMoreData", true);
                   context.commit("SetTaskTypeListForEdit", data.data);
                   return;
               }
               if (Filter.pageId == 1) {
                   context.commit("SetTaskTypeNoMoreData", false);
                   context.commit("SetTaskTypeListForEdit", data.data);
               }
               else {
                   context.commit("SetTaskTypeNoMoreData", false);
                   context.commit("AddTaskTypeListForEdit", data.data);
               }
            });
    },
    
    ClearTaskTypeList(context:any) {
        context.commit("SetTaskTypeList", []);
    },
   
    CreateTaskType(context:any, item:any) {
        context.commit("SetLoading", true);

        axios.post('Task/TaskTypeCreate', item).then((response:any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                context.commit("SetLoading", false);
                const res = response.data.errors.map((a:any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
                return "-1";
            }
            else {
                context.commit("SetLoading", false);
                func.showSuccessMessage("با موفقیت ثبت شد.");
                return response.data.result;
            }
            
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    EditTaskType(context:any, item:any) {
        context.commit("SetLoading", true);

        axios.post('Task/TaskTypeCreate', item).then((response:any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a:any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                router.go(-1);
            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
